module.exports = __webpack_public_path__ + "img/nav-design-classic.3784188.jpg";